function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// Note, overriding formatting options for eslint prettier for this file, to same as cloud-pal-community
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/41d9e5ec25db30078d6c14d5a89fcd4cc0ee63c3/prettier.config.js
/* eslint prettier/prettier: ["error", { jsxBracketSameLine: true, printWidth: 80, singleQuote: true, proseWrap: 'always', arrowParens: 'avoid', }] */

// copied from:
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/8adcdb05a31205b122067c1b649c525db8bf224d/src/components/Connected/RefResolverPicker/components/ApiCombo.jsx

import React, { useState, useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';

// Components
import { Button, ComboBox, Link, SelectSkeleton } from '@carbon/react';
import { Launch, Renew } from '@carbon/react/icons';

// Hooks
import useApi from './hooks/useApi';
import PickerContext from './context/PickerContext';
var dummyFn = function dummyFn() {};
// eslint-disable-next-line react/function-component-definition
var ApiCombo = function ApiCombo(_ref) {
  var _ref$apiOptions = _ref.apiOptions,
    mock = _ref$apiOptions.mock,
    accountId = _ref$apiOptions.accountId,
    providerId = _ref$apiOptions.providerId,
    apiId = _ref$apiOptions.apiId,
    queryParams = _ref$apiOptions.queryParams,
    mockItems = _ref$apiOptions.mockItems,
    autoSelect = _ref.autoSelect,
    comboId = _ref.comboId,
    customItemToString = _ref.customItemToString,
    disabled = _ref.disabled,
    filterIds = _ref.filterIds,
    forceLoading = _ref.forceLoading,
    forceError = _ref.forceError,
    itemId = _ref.itemId,
    linkUrl = _ref.linkUrl,
    onChanged = _ref.onChanged,
    onLoading = _ref.onLoading,
    parsedRef = _ref.parsedRef,
    parsedRefField = _ref.parsedRefField,
    parsedRefItemField = _ref.parsedRefItemField,
    refreshId = _ref.refreshId,
    _ref$showRefresh = _ref.showRefresh,
    showRefresh = _ref$showRefresh === void 0 ? false : _ref$showRefresh,
    _ref$text = _ref.text,
    title = _ref$text.title,
    placeholder = _ref$text.placeholder,
    loadError = _ref$text.loadError,
    _ref$text$linkText = _ref$text.linkText,
    linkText = _ref$text$linkText === void 0 ? '' : _ref$text$linkText,
    _ref$text$refresh = _ref$text.refresh,
    refresh = _ref$text$refresh === void 0 ? '' : _ref$text$refresh,
    _ref$text$noneAvailab = _ref$text.noneAvailable,
    noneAvailable = _ref$text$noneAvailab === void 0 ? '' : _ref$text$noneAvailab;
  // State
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    item = _useState2[0],
    setItem = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  var isEmpty = function isEmpty(obj) {
    return [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
  };

  // Refs
  var isMounted = useRef(false);

  // Context
  var _useContext = useContext(PickerContext),
    envId = _useContext.env_id,
    useCache = _useContext.useCache;

  // Datahook
  var apiResponse = useApi({
    options: {
      mock: mock,
      skip: disabled,
      refetchOnMount: !useCache,
      templateKeys: [accountId, providerId, apiId],
      queryParams: envId ? _objectSpread({
        env_id: envId
      }, queryParams) : queryParams,
      customMockObject: {
        data: {
          items: mockItems
        }
      }
    }
  });

  // Effects
  useEffect(function () {
    // Don't fire callback on mount
    if (isMounted.current) {
      onChanged(item);
    }
    isMounted.current = true;
  }, [item, onChanged]);
  useEffect(function () {
    onLoading(apiResponse.loading);
  }, [apiResponse.loading, onLoading]);
  useEffect(function () {
    var _apiResponse$data;
    if (!apiResponse.loading && !apiResponse.error && (_apiResponse$data = apiResponse.data) !== null && _apiResponse$data !== void 0 && _apiResponse$data.items) {
      var _parsedRef$current;
      var filteredItems = apiResponse.data.items.filter(function (i) {
        return !filterIds || filterIds.length === 0 || filterIds.includes(i.id);
      });
      setItems(filteredItems);
      if (parsedRef !== null && parsedRef !== void 0 && (_parsedRef$current = parsedRef.current) !== null && _parsedRef$current !== void 0 && _parsedRef$current[parsedRefField]) {
        setItem(filteredItems.find(function (i) {
          return i[parsedRefItemField] === parsedRef.current[parsedRefField];
        }) || null);
      } else if (filteredItems.length === 1 && autoSelect) {
        setItem(filteredItems[0]);
      } else {
        setItem(filteredItems.find(function (i) {
          return i.id === itemId;
        }) || null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiResponse.data, apiResponse.error, apiResponse.loading, itemId, autoSelect, filterIds]);
  useEffect(function () {
    if (refreshId > 0) {
      apiResponse.refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshId]);
  if (apiResponse.loading && !disabled || forceLoading) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectSkeleton, {
      style: {
        paddingTop: '0.25rem'
      }
    }));
  }
  var apiIdToFieldMapping = {
    groups: 'secret-group',
    types: 'secret-type',
    items: 'secret',
    keys: 'kvkey'
  };
  var cssFieldName = apiIdToFieldMapping[apiId] || apiId;
  if (showRefresh) {
    // TODO should use a CSS class for styling of button, instead of inline style
    // Compute refresh <Button marginTop from,
    // the <label above the combobox has:
    // div.cds--modal.ocr--secret-picker-modal div.cds--modal-content .cds--label{
    //     padding-top: 15px;
    // .cds--label {
    //     line-height: 1rem;
    //     margin-block-end: 0.5rem;
    // so combining those together, to get the height of the label,
    // and to leave that height as marginTop blank space above the refresh button.
    var refreshButtonMarginTop = 'calc(15px + 1rem + 0.5rem)';
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flexGrow: 1
      }
    }, /*#__PURE__*/React.createElement(ComboBox, {
      className: "cpc--ref-resolver-picker__combobox ocr--".concat(cssFieldName, "-input"),
      id: comboId,
      titleText: title,
      placeholder: isEmpty(items) && !disabled ? noneAvailable : placeholder,
      helperText: linkUrl && linkText && /*#__PURE__*/React.createElement(Link, {
        disabled: false,
        href: linkUrl,
        renderIcon: Launch,
        target: "_blank"
      }, linkText),
      invalid: apiResponse.error || forceError,
      invalidText: loadError,
      items: items || [],
      itemToString: customItemToString || function (i) {
        return i ? i.name : '';
      },
      onChange: function onChange(e) {
        // eslint-disable-next-line no-param-reassign
        parsedRef.current = null;
        setItem(e.selectedItem);
      },
      downshiftProps: {
        selectedItem: item
      },
      selectedItem: item,
      disabled: disabled
    })), /*#__PURE__*/React.createElement(Button, {
      className: cssFieldName === 'secret' ? "ocr--secret-refresh-button" : '',
      style: {
        marginTop: refreshButtonMarginTop,
        height: '1rem'
      },
      tooltipPosition: "left",
      size: "md",
      id: comboId,
      renderIcon: Renew,
      iconDescription: refresh,
      hasIconOnly: true,
      onClick: function onClick() {
        return apiResponse.refetch();
      },
      disabled: disabled || apiResponse.loading
    }));
  }
  return /*#__PURE__*/React.createElement(ComboBox, {
    className: "cpc--ref-resolver-picker__combobox ocr--".concat(cssFieldName, "-input"),
    id: comboId,
    titleText: title,
    placeholder: isEmpty(items) && !disabled ? noneAvailable : placeholder,
    helperText: linkUrl && linkText && /*#__PURE__*/React.createElement(Link, {
      disabled: false,
      href: linkUrl,
      renderIcon: Launch,
      target: "_blank"
    }, linkText),
    invalid: apiResponse.error,
    invalidText: loadError,
    items: items || [],
    itemToString: customItemToString || function (i) {
      return i ? i.name : '';
    },
    onChange: function onChange(e) {
      // eslint-disable-next-line no-param-reassign
      parsedRef.current = null;
      setItem(e.selectedItem);
    },
    downshiftProps: {
      selectedItem: item
    },
    selectedItem: item,
    disabled: disabled
  });
};
ApiCombo.propTypes = {
  apiOptions: PropTypes.shape({
    accountId: PropTypes.string,
    apiId: PropTypes.string.isRequired,
    mock: PropTypes.bool,
    mockItems: PropTypes.arrayOf(PropTypes.shape({})),
    providerId: PropTypes.string,
    queryParams: PropTypes.shape({})
  }),
  autoSelect: PropTypes.bool,
  comboId: PropTypes.string.isRequired,
  customItemToString: PropTypes.func,
  disabled: PropTypes.bool,
  filterIds: PropTypes.arrayOf(PropTypes.string),
  forceLoading: PropTypes.bool,
  forceError: PropTypes.bool,
  itemId: PropTypes.string,
  linkUrl: PropTypes.string,
  onChanged: PropTypes.func,
  onLoading: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  parsedRef: PropTypes.object,
  parsedRefField: PropTypes.string.isRequired,
  parsedRefItemField: PropTypes.string.isRequired,
  refreshId: PropTypes.number,
  showRefresh: PropTypes.bool,
  text: PropTypes.shape({
    title: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    loadError: PropTypes.string.isRequired,
    linkText: PropTypes.string,
    refresh: PropTypes.string,
    noneAvailable: PropTypes.string
  }).isRequired
};
ApiCombo.defaultProps = {
  apiOptions: {
    mock: false
  },
  autoSelect: true,
  customItemToString: null,
  disabled: false,
  filterIds: null,
  forceLoading: false,
  forceError: false,
  itemId: null,
  linkUrl: '',
  onChanged: dummyFn,
  onLoading: dummyFn,
  parsedRef: null,
  refreshId: 0,
  showRefresh: false
};
export default ApiCombo;